module.exports = __webpack_public_path__ + "static/media/exclamation-circle.2fa46f6f.svg";